import Service from "../../services"

const Auth = {
    namespaced: true,
    state: {
        checkLogin: 0,
        role: null,
        accessToken: null,
        user: [],
    },
    mutations: {
        SET_TOKEN: (state, data) => {
            state.accessToken = data.access_token;
            state.user = data.user;
            state.role = data.user.currentRole;
        },
        // SET_TOKEN_REGISTER: (state, token) => {
        //     state.registerToken = token;
        // },
        SET_USER: (state, data) => {
            state.user = data;
        },
        RESET_STATE: (state) => {
            state.user = [];
            state.accessToken = null;
        },
        SET_APPROVE: (state, data) => {
            state.statusApprove = 0;
            // state.statusApprove = data.approveForm;
        },
    },
    actions: {
        // save({commit}, data) {
        //     return Service.News.save().then(res => {
        //         return res;
        //     })
        // },
        delete({ commit }, id) {
            return Service.Auth.delete(id).then(res => {
                return res;
            })
        },
        login({ commit }, data) {
            return Service.Auth.login(data).then(data => {
                commit("SET_TOKEN", data);
                return data;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        register({ commit }, data) {
            return Service.Auth.register(data).then(res => {
                commit('SET_TOKEN_REGISTER', res.access_token)
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        adminRegister({ commit }, data) {
            return Service.Auth.adminRegister(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        adminUpdate({ commit }, data) {
            return Service.Auth.adminUpdate(data).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        updateProfile({ commit }, data) {
            return Service.Auth.updateProfile(data).then(res => {
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        verifyApprove({ commit }, data) {
            return Service.Auth.verifyApprove(data).then(data => {
                return data;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        verifyApproveRegen({ commit }, data) {
            return Service.Auth.verifyApproveRegen(data).then(data => {
                return data;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        approveRegenPost({ commit }, data) {
            return Service.Auth.approveRegenPost(data).then(data => {
                return data;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        logout({ commit }) {
            commit("RESET_STATE");
        },
        getUser({ commit }) {
            return Service.Auth.getUser().then(res => {
                commit("SET_USER", res);
                return res;
            })
        },
    }
}

export default Auth;
